(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["forge-bold-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__forgeBoldFaq) return;
    window.__forgeBoldFaq = true;

    function setOpen(item, open) {
      var trigger = item.querySelector('[data-bold-faq-trigger]');
      var panel = item.querySelector('[data-bold-faq-panel]');
      if (!trigger || !panel) return;
      item.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }

    function closeOthers(list, except) {
      list.querySelectorAll('[data-bold-faq-item].is-open').forEach(function (openItem) {
        if (openItem !== except) setOpen(openItem, false);
      });
    }

    function itemFromEvent(event) {
      var origin = event.target;
      if (!origin) return null;
      if (origin.nodeType !== 1) origin = origin.parentElement;
      if (!origin || !origin.closest) return null;
      if (origin.closest('[data-bold-faq-panel]')) return null;
      return origin.closest('[data-bold-faq-item]');
    }

    document.addEventListener('click', function (event) {
      var item = itemFromEvent(event);
      if (!item) return;
      var list = item.closest('[data-bold-faq]');
      if (!list) return;
      var isOpen = item.classList.contains('is-open');
      closeOthers(list, item);
      setOpen(item, !isOpen);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var item = itemFromEvent(event);
      if (!item && event.detail && event.detail.blockId) {
        var byId = document.getElementById('shopify-block-' + event.detail.blockId);
        if (byId) {
          item = byId.hasAttribute('data-bold-faq-item')
            ? byId
            : byId.closest('[data-bold-faq-item]') || byId.querySelector('[data-bold-faq-item]');
        }
      }
      if (!item) return;
      var list = item.closest('[data-bold-faq]');
      if (!list) return;
      closeOthers(list, item);
      setOpen(item, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
